// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mU5InHR0Z19NdrsRdrIE {
  /* Shared styling for the gods and kings theme (base + VIP) */
  --jp-level-value-align: end;
  --jp-level-value-padding-right: 45px;
  --jp-currency-margin-left: 5px;
  --jp-currency-line-height: 1;
  --jp-value-font-weight: 500;
  --jp-grand-currency-font-size: 11px;
  --jp-major-currency-font-size: 10px;
  --jp-minor-currency-font-size: 9.5px;
  --jp-mini-currency-font-size: 9px;
  --jp-grand-font-size: 37px;
  --jp-major-font-size: 35px;
  --jp-minor-font-size: 33px;
  --jp-minor-font-size: 30px;
  --jp-grand-width: 250px;
  --jp-major-width: 221px;
  --jp-minor-width: 194px;
  --jp-mini-width: 154px;
  --jp-grand-height: 40px;
  --jp-major-height: 38px;
  --jp-minor-height: 35px;
  --jp-mini-height: 35px;
  grid-auto-flow: column;
  /* Panel icon styling */
}
.mU5InHR0Z19NdrsRdrIE div[data-type='levelsContainer'] {
  grid-template-columns: 1fr;
  row-gap: 13px;
  margin-left: -149px;
  justify-items: end;
}
.mU5InHR0Z19NdrsRdrIE div[data-type='panelIcon'] {
  width: auto;
  height: 221px;
  position: relative;
}
.mU5InHR0Z19NdrsRdrIE div[data-type='panelIcon'] picture {
  width: inherit;
  height: inherit;
}
.mU5InHR0Z19NdrsRdrIE div[data-type='panelIcon'] picture img {
  width: inherit;
  height: inherit;
  object-fit: contain;
}
.mU5InHR0Z19NdrsRdrIE div[data-level='mini'] {
  font-size: 30px;
}
@media (max-width: 1025px) {
  .mU5InHR0Z19NdrsRdrIE {
    /* Level Font Size */
    --jp-grand-font-size: 34px;
    --jp-major-font-size: 32px;
    --jp-minor-font-size: 30px;
    --jp-mini-font-size: 28px;
    --jp-grand-width: 229px;
    --jp-minor-width: 174px;
    --jp-major-width: 201px;
    --jp-mini-width: 140px;
    --jp-grand-height: 38px;
    --jp-major-height: 36px;
    --jp-minor-height: 34px;
    --jp-mini-height: 33px;
    --jp-grand-currency-font-size: 10px;
    --jp-major-currency-font-size: 10px;
    --jp-minor-currency-font-size: 10px;
    --jp-mini-currency-font-size: 9px;
  }
  .mU5InHR0Z19NdrsRdrIE div[data-type='levelsContainer'] {
    margin-left: -100px;
    row-gap: 10px;
  }
  .mU5InHR0Z19NdrsRdrIE div[data-type='panelIcon'] {
    width: auto;
    height: 200px;
  }
  .mU5InHR0Z19NdrsRdrIE div[data-level='mini'] {
    font-size: 28px;
  }
}
@media (orientation: portrait) {
  .mU5InHR0Z19NdrsRdrIE {
    margin-top: 1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/jackpots/components/variants/base/GodsAndKings.base.module.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;IACpB,0BAA0B;IAC1B,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;IACnC,iCAAiC;EACnC;EACA;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".godsAndKingsTheme {\n  /* Shared styling for the gods and kings theme (base + VIP) */\n  --jp-level-value-align: end;\n  --jp-level-value-padding-right: 45px;\n  --jp-currency-margin-left: 5px;\n  --jp-currency-line-height: 1;\n  --jp-value-font-weight: 500;\n  --jp-grand-currency-font-size: 11px;\n  --jp-major-currency-font-size: 10px;\n  --jp-minor-currency-font-size: 9.5px;\n  --jp-mini-currency-font-size: 9px;\n  --jp-grand-font-size: 37px;\n  --jp-major-font-size: 35px;\n  --jp-minor-font-size: 33px;\n  --jp-minor-font-size: 30px;\n  --jp-grand-width: 250px;\n  --jp-major-width: 221px;\n  --jp-minor-width: 194px;\n  --jp-mini-width: 154px;\n  --jp-grand-height: 40px;\n  --jp-major-height: 38px;\n  --jp-minor-height: 35px;\n  --jp-mini-height: 35px;\n  grid-auto-flow: column;\n  /* Panel icon styling */\n}\n.godsAndKingsTheme div[data-type='levelsContainer'] {\n  grid-template-columns: 1fr;\n  row-gap: 13px;\n  margin-left: -149px;\n  justify-items: end;\n}\n.godsAndKingsTheme div[data-type='panelIcon'] {\n  width: auto;\n  height: 221px;\n  position: relative;\n}\n.godsAndKingsTheme div[data-type='panelIcon'] picture {\n  width: inherit;\n  height: inherit;\n}\n.godsAndKingsTheme div[data-type='panelIcon'] picture img {\n  width: inherit;\n  height: inherit;\n  object-fit: contain;\n}\n.godsAndKingsTheme div[data-level='mini'] {\n  font-size: 30px;\n}\n@media (max-width: 1025px) {\n  .godsAndKingsTheme {\n    /* Level Font Size */\n    --jp-grand-font-size: 34px;\n    --jp-major-font-size: 32px;\n    --jp-minor-font-size: 30px;\n    --jp-mini-font-size: 28px;\n    --jp-grand-width: 229px;\n    --jp-minor-width: 174px;\n    --jp-major-width: 201px;\n    --jp-mini-width: 140px;\n    --jp-grand-height: 38px;\n    --jp-major-height: 36px;\n    --jp-minor-height: 34px;\n    --jp-mini-height: 33px;\n    --jp-grand-currency-font-size: 10px;\n    --jp-major-currency-font-size: 10px;\n    --jp-minor-currency-font-size: 10px;\n    --jp-mini-currency-font-size: 9px;\n  }\n  .godsAndKingsTheme div[data-type='levelsContainer'] {\n    margin-left: -100px;\n    row-gap: 10px;\n  }\n  .godsAndKingsTheme div[data-type='panelIcon'] {\n    width: auto;\n    height: 200px;\n  }\n  .godsAndKingsTheme div[data-level='mini'] {\n    font-size: 28px;\n  }\n}\n@media (orientation: portrait) {\n  .godsAndKingsTheme {\n    margin-top: 1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"godsAndKingsTheme": `mU5InHR0Z19NdrsRdrIE`
};
export default ___CSS_LOADER_EXPORT___;
